import { FiUser } from 'react-icons/fi';
import { useCachedImage } from '@/hooks/useCachedImage';
import { cn } from '@/lib/utils';

export interface UserAvatarProps {
  photoURL?: string | null;
  username: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeClasses = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-12 w-12',
  xl: 'h-24 w-24',
};

const iconSizeClasses = {
  sm: 'h-5 w-5',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
  xl: 'h-12 w-12',
};

export const UserAvatar: React.FC<UserAvatarProps> = ({
  photoURL,
  username,
  size = 'md',
  className,
}) => {
  const cachedPhotoURL = useCachedImage(photoURL || null);

  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    // If image fails to load, hide it to show fallback avatar
    e.currentTarget.style.display = 'none';
  };

  return (
    <div
      className={cn(
        'user-avatar-component rounded-full bg-primary/20 flex items-center justify-center overflow-hidden flex-shrink-0',
        sizeClasses[size],
        className
      )}
    >
      {cachedPhotoURL ? (
        <img
          src={cachedPhotoURL}
          alt={username}
          className="h-full w-full object-cover"
          onError={handleImageError}
        />
      ) : null}
      {!cachedPhotoURL && (
        <FiUser className={cn('text-primary', iconSizeClasses[size])} />
      )}
    </div>
  );
};

